import * as z from "zod";

export const WarrantyRegistrationFlatTeamSettingsSchema = z.object({
  "warranties/purchaseChannels": z
    .array(z.object({ displayName: z.string(), purchaseChannel: z.string() }))
    .nullish(),
  "warranties/purchaseChannelRegistrationCollection": z
    .array(
      z.object({
        collectionId: z.string().nullish(),
        purchaseChannel: z.string(),
      }),
    )
    .nullish(),
});
